module.exports = __webpack_public_path__ + "img/梨园乡-c.7d2f9945.png";